<template>
  <div class="page-mine">
    我的
  </div>
</template>

<script>
	export default {
		name: "index"
	}
</script>

<style scoped>

</style>
